export default __webpack_public_path__ + "static/media/kayaguneriuc2.67639e1e.jpg";